import type { ReactNode } from 'react'

type ShowModal = (modal: ReactNode) => void

/**
 * Opens the site-takeover campaign modal without creating a static import cycle
 * between TagLabel/USP and SiteTakeoverCampaignModal.
 */
export async function openSiteTakeoverCampaignModal(showModal: ShowModal): Promise<void> {
  const { default: SiteTakeoverCampaignModal } = await import('./SiteTakeoverCampaignModal')
  showModal(<SiteTakeoverCampaignModal />)
}
